const About=()=>{
    return (
        <div className="container">
            <div className="row pb-5">
                <h2 className="section-title  pb-4">About us</h2>
              
        
 <div className="row about pt-4"> 

<div className="about-img col-md-6">
<img src="weather.avif" alt="weather"/>
</div>
<div className="feature col-md-6">
<h4 className="text-center fw-bold">Why choose us?</h4>
<p className="text">We aim to provide clear, reliable weather forecasts to help users to make informed decisions about their daily activities. </p>  
<ul className="about-list">
<li>Global Coverage</li>
<li>Easy-to-Use Interface</li>
{/* <li>Reliability</li> */}
<li>Real-Time Weather Updates</li>
<li>Hourly Forecasts</li>
<li>5-Day Weather Forecast</li>
</ul>
</div>
            </div>
          
            </div>

        </div>
    )
}
export default About;